import { LessonIllustration, ManualDeputateIllustration, TransferQuotaTableIllustration } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconMenu } from '../../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../../components/IconMenuItem/IconMenuItem';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';
import { useUserConfigContext } from '../../../hooks/useUserConfigContext';

export const DeputatePlanPage = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const schoolYear = useUserConfigContext().selectedSchoolYear;
  const permissions = usePermissionChecker();

  return (
    <Page
      isForbidden={!permissions?.canReadDeputate()}
      title={`${t('deputate.title', { count: 2 })} ${t('deputate.plan').toLowerCase()}`}
      fullHeight
    >
      <IconMenu
        headline={t('schoolYear.selectedSchoolyear', {
          year: schoolYear?.name,
        })}
      >
        <IconMenuItem
          label={t('lesson.title', { count: 2 })}
          icon={<LessonIllustration />}
          bubbleType={18}
          onClick={() => navigate(t('routes.lessons.slug'))}
        />
        <IconMenuItem
          label={t('deputate.manual')}
          icon={<ManualDeputateIllustration />}
          bubbleType={15}
          onClick={() => navigate(t('routes.deputate.additional.slug'))}
        />
        <IconMenuItem
          label={t('curriculum.transferCurriculum')}
          icon={<TransferQuotaTableIllustration />}
          bubbleType={13}
          onClick={() => navigate(t('routes.curriculum.transferCurriculum.slug'))}
        />
      </IconMenu>
    </Page>
  );
});
